import { FooterProps } from '../../../components/footer/types/propsTypes';
import { FooterImageData } from '../../../components/legalLink/types/propsTypes';
import { SocialIcon } from '../../../components/socialIcon/types/propsTypes';
import { FooterLink, HelpingData } from '../../../components/footerNavigation/types/propsTypes';
import { CMSTransformerDataType } from '../../types/common';
import { LinkDefination } from '../../../components';
const footerTransformer = (data: CMSTransformerDataType): FooterProps => {
  const { bottom_section, main_navigation, social_links, top_navigation } = data;
  const { links, right_icons, copyright_message } = bottom_section || {};
  const legalLinkData: LinkDefination[] = links;
  const legalImageData: FooterImageData[] = [];
  right_icons?.forEach((item: CMSTransformerDataType) => {
    const { url } = item.image;
    const data = {
      alt: item.alt,
      url,
      link: item.link,
    };
    legalImageData.push(data);
  });

  const legalLink = {
    disclaimer: copyright_message,
    link: legalLinkData,
    footerImage: legalImageData,
  };

  const socialLinkData: SocialIcon[] = [];
  social_links?.forEach((item: CMSTransformerDataType) => {
    const {
      alt,
      image: { url },
      link: { text },
    } = item;
    const iconData = {
      alt,
      url,
      href: text,
    };
    socialLinkData.push({
      link: item?.link,
      icon: iconData,
    });
  });

  const topNavigation: HelpingData[] = [];

  top_navigation?.forEach((item: CMSTransformerDataType) => {
    const {
      alt,
      description,
      image: { url },
      link,
      title,
    } = item;
    const data = {
      alt,
      description,
      imageUrl: url,
      button: {
        text: link?.text,
        target: link?.target,
        url: link?.url,
      },
      title,
    };

    topNavigation.push(data);
  });

  const { footer_links_group } = main_navigation || {};

  const mainNavigationData: FooterLink[] = [];

  footer_links_group?.forEach((item: CMSTransformerDataType) => {
    const { group_title, links } = item;

    const linkData: CMSTransformerDataType = [];

    links?.forEach((linkdataItem: CMSTransformerDataType) => {
      linkData.push(linkdataItem);
    });

    mainNavigationData.push({
      heading: group_title,
      subheading: linkData,
    });
  });

  const footer = {
    helpingData: topNavigation,
    footerData: mainNavigationData,
    footerIcon: socialLinkData,
    legalLink: legalLink,
  };

  return {
    footer: footer,
    componentType: 'footer',
  };
};

export default footerTransformer;
